import { QueryClient } from 'react-query';

import { queryClientConfig } from 'hooks/config';

export const queryClient = new QueryClient(queryClientConfig);
